angular.module('impactx.rfx').controller('RFXSupportListRunningCtrl', ['$scope', '$redirect', 'selectedListItems', RFXSupportListRunningCtrl]);

function RFXSupportListRunningCtrl($scope, $redirect, selectedListItems) {
    var self = this;

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'RFXSupportView'
        }

    ];

    this.meta = {
        rowTemplate: 'modules/rfx/templates/rfxsupportlist.row.tmpl.html',
        filtersTemplate: 'modules/rfx/templates/rfxsupportlist.filters.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/support/listrunning',
        id: "rfxsupportlistrunning",
        buttonDefinition: buttonDefinition,
        valuesInteger: [
            {
                name: 'STATUS_READY_FOR_PUBLISH',
                value: 12
            },
            {
                name: 'STATUS_PUBLISHED',
                value: 18
            },
            {
                name: 'STATUS_DECIDED',
                value: 65
            },
            {
                name: 'STATUS_DONE',
                value: 70
            }
        ]
    };

    this.getMeta = function () {
        return this.meta;
    };

    this.processStatus = {value: "running"};
    $scope.$watch(function () {
        return self.processStatus.value;
    }, function (newValue) {
        if (newValue === "closed") {
            $redirect.redirectTo(null, "/rfxsupportlistclosed");
        }
    });

    function getDetailLink() {
        return "rfxsupport/" + selectedListItems.getFirstSelectedId();
    }
}